<template>
  <div>
    <b-modal no-fade size="lg" id="modal-customer" no-close-on-esc no-close-on-backdrop title="Clientes">
      <b-row>
        <b-col lg="3">
          <b-form-group label="Código" label-size="sm" label-for="cliente_id">
            <b-form-input
              maxlength="10"
              size="sm"
              id="cliente_id"
              v-model="customer.cliente_id"
              disabled
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group label="Razão Social" label-size="sm" label-for="razao_social">
            <b-form-input
              size="sm"
              id="razao_social"
              maxlength="100"
              v-model="customer.razao_social"
              :disabled="action === 'view'"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="3">
          <b-form-group label="Tipo" label-size="sm" label-for="ind_tipo_pessoa">
            <v-select
                id="ind_tipo_pessoa"
                :disabled="action === 'view'"
                :options="[{ label: 'Física', id: 'F'}, { label: 'Jurídica', id: 'J'}]"
                label="label"
                :reduce="tip => tip.id"
                :clearable="false"
                :searchable="false"
                v-model="customer.ind_tipo_pessoa">
            </v-select>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="CNPJ/CPF" label-size="sm" label-for="cpf_cnpj">
            <b-form-input
              size="sm"
              id="cpf_cnpj"
              ref="cpf_cnpj"
              maxlength="20"
              v-model="customer.cpf_cnpj"
              :disabled="action === 'view'"
              trim
              v-mask="{ mask: '99.999.999/9999-99', greedy: true}"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="I.E./RG" label-size="sm" label-for="rg_ie">
            <b-form-input
              size="sm"
              id="rg_ie"
              maxlength="20"
              v-model="customer.rg_ie"
              :disabled="action === 'view'"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>      
      <template v-slot:modal-footer>
        <b-button v-if="action !== 'view'" size="sm" @click="saveRecord()" variant="primary">
          <i class="fas fa-check"></i> Gravar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-customer')">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "ModalCustomer",
  props: {
    customer: { type: Object, required: true },
    action: { type: String, required: true, default: "view" }
  },
  computed: {
  },
  methods: {
    validateRecord() {
      let _msg = "";

      if ((this.customer.razao_social || "") === "") _msg = "Informe a Razão Social";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning"
        });
        return false;
      }
      return true;
    },
    saveRecord() {
      if (!this.validateRecord()) return;

      if (this.action === "new") {
        axios
          .post(`${baseApiUrl}/clientes`, this.customer)
          .then(() => {
            this.$bvModal.hide("modal-customer");
            this.$emit("updated");
          })
          .catch(err => {
            showError(err);
          });
      } else {
        axios
          .put(`${baseApiUrl}/clientes/${this.customer.cliente_id}`, this.customer)
          .then(() => {
            this.$bvModal.hide("modal-customer");
            this.$emit("updated");
          })
          .catch(err => {
            showError(err);
          });
      }
    }
  }
};
</script>

<style>
</style>